





















import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'

settings =
  name: "BrandRepInfoStep"

  vue:
    props: ['wizard']
    mixins: [WizardService.step()]

    methods:
      validateStep: ->
        @validateEmail()

      validateEmail: ->
        re = /\S+@\S+\.\S+/
        @wizard.setStepError 'email', 'Email not valid' if !re.test(@wizard.brandRepInfo.email)

export default VueOptions.vue settings
